import { module } from 'modujs';
import { getViewport } from '../utils/utilities';
import Channels from '../base/channels';
import gsap from 'gsap';
import { RevealFade } from '../modules';
import { ScrollTrigger } from '../vendor/gsap-esm/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    this.VARS = {
      TRIGGER: false,
    };
    this.call();
    this.observe();
  }

  animate() {
    gsap.fromTo(
      this.DOM.view,
      { autoAlpha: 0, y: 50 },
      {
        autoAlpha: 1,
        y: 0,
        duration: 1,
        ease: 'cubic.out',
        delay: 0.5,
        scrollTrigger: {
          trigger: this.DOM.view,
          markers: false,
          start: 'top 80%',
        },
      }
    );
  }

  call() {
    this.VARS.TRIGGER = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this.DOM.view);

      const url = this.DOM.view.dataset.url;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector(
            'product-recommendations-custom'
          );
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.DOM.view.innerHTML = recommendations.innerHTML;
            this.modules.app.app.update(this.DOM.view.querySelector('div'));
            Channels.emit('scroll::refresh');
            this.animate();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };
  }

  observe() {
    const viewport = getViewport();
    const observer = new IntersectionObserver(this.VARS.TRIGGER, {
      rootMargin: `0px 0px ${viewport.height}px 0px`,
    });
    observer.observe(this.DOM.view);
  }
}
